import { render } from "./NeoFooter.vue?vue&type=template&id=64294b75"
import script from "./NeoFooter.vue?vue&type=script&lang=js"
export * from "./NeoFooter.vue?vue&type=script&lang=js"

import "./NeoFooter.vue?vue&type=style&index=0&id=64294b75&lang=scss"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__